import React, { useState } from "react";
import { TabContent, TabPane } from "reactstrap";
import {
  Card,
  CardBody,
} from "react-bootstrap";
import "./index.css";
import RestaurantWallet from "./RestaurantWallet";
import BankDetails from "./BankDetails";
import BreadCrumbs from "../../../components/BreadCrumbs";
import PillNavigation from "../../../components/SubNavBar";
import { NAV_LIST_RESTAURANT_VIEW } from "../../../constants/constans";
import EditReasturant from "./EditRestaurant";
import { useLocation } from "react-router-dom";



const RestaurantView: React.FC = () => {
  const location = useLocation();

  const [active, setActive] = useState(1);

  const toggle = (tab: any) => {
    setActive(tab);
  };

  const restaurants = location.state?.restaurant;


  return (
    <>
      <BreadCrumbs hasSubMenus={false} />
      <br />
      <Card className="cart-view-whole-card">
        <CardBody>
          <div className="Cart-view-nav-bar">
            <PillNavigation
              navList={NAV_LIST_RESTAURANT_VIEW.map((navItem, index) => {
                return {
                  ...navItem,
                };
              })}
              active={active}
              toggle={toggle}
            />
          </div>
      
          <TabContent activeTab={active} className="mt-1">
            {active === 1 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={1}>
                  <EditReasturant/>
                </TabPane>
              </div>
            )}
            {active === 2 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={2}>
                  <RestaurantWallet />
                </TabPane>
              </div>
            )}

            {active === 3 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={3}>
                  <BankDetails restaurantData={restaurants} />
                </TabPane>
              </div>
            )}

          </TabContent>
        </CardBody>
      </Card>
    </>
  );
};

export default RestaurantView;
